'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoMatches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoMatches = exports.NoMatches = function NoMatches() {
  return _react2.default.createElement(
    'ul',
    null,
    _react2.default.createElement(
      'li',
      { className: 'dropdown__item searchbox__no-matches' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'searchbox.item.nomatches',
        defaultMessage: 'No matches'
      })
    )
  );
};